import {useI18Next} from '../../../../../common/helpers/react/hooks/useI18Next';
import {ColumnDescription} from '../../../common/components/table/ColumnDescription';
import {HistoryEntry} from '../../../../../common/model/types/history/HistoryEntry';

/**
 * Vertical cell padding in pixels driving the row height.
 * Table default (see getColumnStyle) is 12 - lower it for narrower rows.
 */
const CELL_PADDING_Y = 6;

const CELL_STYLE = {
    minWidth: '11rem',
    paddingTop: CELL_PADDING_Y,
    paddingBottom: CELL_PADDING_Y
};

export const useHistoryTableColumns = (): ColumnDescription<HistoryEntry>[] => {
    const {t} = useI18Next();

    const columns: ColumnDescription<HistoryEntry>[] = [
        {
            name: 'date_time',
            header: t('DATE_TIME'),
            size: 2,
            sortable: true,
            sortKey: 'dateTime'
        },
        {
            name: 'edited_by_id',
            header: t('EDITED_BY_ID'),
            size: 1,
            sortable: true,
            sortKey: 'editedById'
        },
        {
            name: 'edited_by_name',
            header: t('EDITED_BY_NAME'),
            size: 2,
            sortable: true,
            sortKey: 'editedByName'
        },
        {
            name: 'change_type',
            header: t('CHANGE_TYPE'),
            size: 1,
            sortable: true,
            sortKey: 'changeType'
        },
        {
            name: 'group_name',
            header: t('GROUP_NAME'),
            size: 2,
            undefinedFallback: '',
            sortable: true,
            sortKey: 'groupName'
        },
        {
            name: 'agent_name',
            header: t('AGENT_NAME'),
            size: 2,
            undefinedFallback: '',
            sortable: true,
            sortKey: 'agentName'
        },
        {
            name: 'agent_id',
            header: t('AGENT_ID'),
            size: 1,
            undefinedFallback: '',
            sortable: true,
            sortKey: 'agentId'
        },
        {
            name: 'product_name',
            header: t('PRODUCT_NAME'),
            size: 1,
            undefinedFallback: '',
            sortable: true,
            sortKey: 'productName'
        },
        {
            name: 'new_setting',
            header: t('NEW_SETTING'),
            size: 2,
            undefinedFallback: '',
            sortable: true,
            sortKey: 'newSetting'
        }
    ];

    return columns.map(column => ({
        ...column,
        cellProps: () => ({style: CELL_STYLE}),
        headerCellProps: () => ({style: CELL_STYLE})
    }));
};
